(function($) {
  "use strict";
  $(document).ready(function() {
    quickView();
  });

  function quickView() {
    // Add quickview if it doesn't exist
    if ( ! $( "#qv_modal" ).length ) {
      let qv_modal = $('<div>', { "id": "qv_modal" }).appendTo('body');

      // Init modal
      qv_modal.popup({
        background: false,
        horizontal: 'right',
        vertical: 'bottom',
        focusdelay: 400, // for smoother slide-in animations on Android
        // closebutton: true,
        // keepfocus: false,
        autozindex: true,
        // blur: false
      });

      $(".qv_product_link").click(function (e) {
        e.preventDefault();
      
        let product_handle = $(this).data('product-handle');
        let product_quantity = parseInt( $(this).data('product-quantity') );
        product_quantity = product_quantity ? product_quantity : 0;

        ($).getJSON('/products/' + product_handle + '.js', function (product) {
          qv_modal.html(qv_content);
          
          let title = product.title;
          let type = product.type;
          let price = 0;
          let price_original = 0;
          let desc = product.description;
          let featured_image = product.featured_image.replace('.jpg', '_100x.jpg').replace('.png', '_100x.png');;
          let options = product.options;
          let url = '/products/' + product_handle;
          qv_modal.find( ".qv-product-title a" ).attr( "href", url).text( title );
          qv_modal.find( ".qv-product-title a" ).text( title );
          qv_modal.find( ".qv-product-type" ).text( type );

          // Create our number formatter.
          let formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          });

          // Total price.
          let price_total = formatter.format((product.price * product_quantity / 100).toFixed(2));

          price = formatter.format((product.price / 100).toFixed(2));
          price_original = formatter.format((product.compare_at_price / 100).toFixed(2));
          
          $('.qv-product-price').text(price);
          if (product_quantity) {
            $('.qv-product-price-total').text(price_total).after( $( "<span>", { "style": "font-size:0.7em;" } ).text(" / " + product_quantity + "x  installed" ) ); 
          } else {
            $('.qv-product-price-total').append( $( "<span>", { "style": "color: #aaa;" } ).text("Not included ") );
          }
          
          $('.view-product').attr( { "href": url } );
          $('.qv-product-image a').attr( "href", url);
          $('.qv-product-image img').attr( { "src": featured_image, "alt": title } );

          // enable/show qv_modal
          qv_modal.popup('show');

          // images.each(function (i, image) {
          //   if (i == imageCount - 1) {
          //     let image_embed = '<div><img src="' + image + '"></div>';
          //     image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          //     $('.qv-product-images').append(image_embed);
          //   } else {
          //     image_embed = '<div><img src="' + image + '"></div>';
          //     image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          //     $('.qv-product-images').append(image_embed);
          //   }
          // });
        });
        

        // $('#qv_modal').popup({
        //   type: 'tooltip',
        //   autoopen: true,
        //   tooltipanchor: this_click,
        //   offsetleft: 0,
        //   offsettop: '-15',
        //   vertical: 'top',
        //   horizontal: 'center'
        // });

      });
    }
  };
})(jQuery);